import { I18NTranslateModule } from '@ebw-monorepo/i18n-translate';
import { MaterialModule } from '@ebw-monorepo/material';
import { NavigationService } from './services/navigation.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationButtonComponent } from './navigation-button/navigation-button.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    I18NTranslateModule
  ],
  providers: [
    NavigationService
  ],
  declarations: [
    NavigationButtonComponent
  ],
  exports: [
    NavigationButtonComponent
  ]
})
export class NavigationModule { }
